module.exports = __webpack_public_path__ + "img/05.72edb4ff.jpg";